import { render } from "./field.vue?vue&type=template&id=5836e4c6&scoped=true&ts=true"
import script from "./field.vue?vue&type=script&lang=ts"
export * from "./field.vue?vue&type=script&lang=ts"

import "./field.vue?vue&type=style&index=0&id=5836e4c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5836e4c6"]])

export default __exports__